"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WixSdkAdapter = void 0;
var tslib_1 = require("tslib");
var timedOut_1 = require("../timedOut");
var AppSectionId_1 = require("../../enums/AppSectionId");
var AppId_1 = require("../../enums/AppId");
var win_1 = require("../win");
var sleep_1 = require("../sleep");
var omitValues_1 = require("../omitValues");
var errorHandling_1 = require("../errorHandling");
var WixSdkAdapter = /** @class */ (function () {
    function WixSdkAdapter(params) {
        var _this = this;
        this.isAvailable = function () {
            return (typeof _this.windowRef !== 'undefined' &&
                typeof _this.windowRef.Wix !== 'undefined' &&
                // in BM env window.Wix is different SDK without instance re-validation support
                _this.windowRef.Wix.hasOwnProperty('revalidateSession'));
        };
        this.isConnected = function () {
            // it's possible that WixSDK is available but the frame is rendered out of Viewer context (e.g. Hotels/Restaurants)
            // this means most of the WixSDK features won't be available, and callbacks will hang
            return _this.isAvailable() && _this.getViewMode() !== 'standalone';
        };
        this.isUserOfUserSignedIn = function () {
            return Boolean(_this.getMemberId());
        };
        this.getMemberId = function () {
            return ((_this.isAvailable() && _this.Wix.Utils.getInstanceValue('uid')) || null);
        };
        this.getVisitorId = function () {
            return ((_this.isAvailable() && _this.Wix.Utils.getInstanceValue('aid')) || null);
        };
        this.getSiteOwnerId = function () {
            return (_this.isAvailable() && _this.Wix.Utils.getSiteOwnerId()) || null;
        };
        this.getLocale = function () {
            return (_this.isAvailable() && _this.Wix.Utils.getLocale()) || null;
        };
        this.getDeviceType = function () {
            return (_this.isAvailable() && _this.Wix.Utils.getDeviceType()) || null;
        };
        this.getViewMode = function () {
            return (_this.isAvailable() && _this.Wix.Utils.getViewMode()) || null;
        };
        this.getMetasiteId = function () {
            return ((_this.isAvailable() && _this.Wix.Utils.getInstanceValue('metaSiteId')) ||
                null);
        };
        this.isWalletAppInstalled = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_1;
            var _this = this;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (!this.isConnected() ||
                            typeof this.Wix.isAppSectionInstalled !== 'function') {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, timedOut_1.timedOut(new Promise(function (resolve) {
                                _this.Wix.isAppSectionInstalled(AppSectionId_1.AppSectionId.Wallet, {
                                    appDefinitionId: AppId_1.AppId.Wallet,
                                }, resolve);
                            }), 3000, function () {
                                var _a;
                                (_a = _this.captureError) === null || _a === void 0 ? void 0 : _a.call(_this, new Error("Failed to assert if Wallet is installed, callback passed to Wix.isAppSectionInstalled wasn't called in time"));
                                return false;
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                    case 2:
                        e_1 = _b.sent();
                        (_a = this.captureError) === null || _a === void 0 ? void 0 : _a.call(this, errorHandling_1.prependMessageToError(e_1, "Failed to assert if Wallet is installed"));
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.openModal = function (params) {
            if (!_this.isConnected() || typeof _this.Wix.openModal !== 'function') {
                throw new Error("Wix.openModal is not available");
            }
            _this.Wix.openModal(params.url, params.width, params.height, params.onClose, params.theme);
        };
        this.isAppInstanceChangeTrackable = function () {
            return (_this.isConnected() && _this.Wix.Events.hasOwnProperty('INSTANCE_CHANGED'));
        };
        this.isRevalidateAppInstanceAvailable = function () {
            return (_this.isConnected() && typeof _this.Wix.revalidateSession === 'function');
        };
        this.getQueryParamsFromURL = function () {
            var _a, _b, _c, _d;
            return (_d = (_c = (_b = (_a = _this.windowRef) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.search) === null || _c === void 0 ? void 0 : _c.slice(1).split('&').map(function (pair) { return pair.split('='); })) === null || _d === void 0 ? void 0 : _d.reduce(function (prevParams, _a) {
                var _b;
                var _c = tslib_1.__read(_a, 2), param = _c[0], value = _c[1];
                return (tslib_1.__assign(tslib_1.__assign({}, prevParams), (_b = {}, _b[param] = value, _b)));
            }, {});
        };
        this.getAppInstanceFromQuery = function () {
            return _this.getQueryParamsFromURL().instance;
        };
        this.getDateNumberFormatFromQuery = function () {
            return _this.getQueryParamsFromURL().dateNumberFormat;
        };
        this.isPrimaryLanguageParamFromQueryExists = function () {
            return _this.getQueryParamsFromURL().hasOwnProperty('isPrimaryLanguage');
        };
        this.revalidateAppInstance = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (!this.isRevalidateAppInstanceAvailable()) {
                    throw new Error("Wix.revalidateSession is not available");
                }
                return [2 /*return*/, timedOut_1.timedOut(new Promise(function (resolve, reject) {
                        _this.Wix.revalidateSession(function (result) {
                            if (typeof (result === null || result === void 0 ? void 0 : result.instance) === 'string') {
                                resolve(result.instance);
                            }
                            else {
                                reject((result === null || result === void 0 ? void 0 : result.error) || new Error('Failed to revalidate session'));
                            }
                        }, reject);
                    }), 5000, function () {
                        throw new Error("Failed to revalidate session, callback passed to Wix.revalidateSession wasn't called in time");
                    })];
            });
        }); };
        this.listenAppInstanceChange = function (listener) {
            if (!_this.isAppInstanceChangeTrackable()) {
                throw new Error("appInstance is not available for tracking via Wix SDK");
            }
            var handleInstanceChange = function (payload) {
                listener(payload === null || payload === void 0 ? void 0 : payload.instance);
            };
            _this.Wix.addEventListener(_this.Wix.Events.INSTANCE_CHANGED, handleInstanceChange);
            return function () {
                _this.Wix.removeEventListener(_this.Wix.Events.INSTANCE_CHANGED, handleInstanceChange);
            };
        };
        this.getPublicDataItem = function (key) {
            return new Promise(function (resolve) {
                var getItemPromise = _this.Wix.Data.Public.get(key, {
                    scope: _this.Wix.Data.SCOPE.COMPONENT,
                }, resolve, 
                // in case if key wasn't found WixSDK throws a rejection
                function () { return resolve({}); });
                return Promise.race([
                    getItemPromise,
                    // when Public.get is run not in real site context (storybook, tests, local server) it won't ever resolve
                    // thus need to limit max time waiting
                    sleep_1.sleep(5000).then(function () { return ({}); }),
                ]);
            }).then(function (map) { return map === null || map === void 0 ? void 0 : map[key]; });
        };
        this.getPublicData = function (keys) {
            return Promise.all(keys.map(function (key) {
                return _this.getPublicDataItem(key).then(function (value) { return ({ key: key, value: value }); });
            })).then(function (entries) {
                return omitValues_1.omitValues(entries.reduce(function (acc, entry) {
                    var _a;
                    return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[entry.key] = entry.value, _a)));
                }, {}), [undefined]);
            });
        };
        // pass dummy cb because by default js-sdk-wrapper will provide getSiteColors,
        // getSiteTextPresets, getStyleParamsthat will expect a callback, while it's not really required
        // (without cb js-sdk-wrapper will throw an error 'cb is not a function')
        this.getSiteColors = function () {
            return ((_this.isAvailable() && _this.Wix.Styles.getSiteColors(function () { })) || null);
        };
        this.getSiteTextPresets = function () {
            return ((_this.isAvailable() && _this.Wix.Styles.getSiteTextPresets(function () { })) ||
                null);
        };
        this.getStyleParams = function () {
            return ((_this.isAvailable() && _this.Wix.Styles.getStyleParams(function () { })) || null);
        };
        this.getSiteStyles = function () {
            if (!_this.isAvailable) {
                return null;
            }
            return {
                siteColors: _this.getSiteColors(),
                siteTextPresets: _this.getSiteTextPresets(),
                styleParams: _this.getStyleParams(),
            };
        };
        this.getWindowRef = params === null || params === void 0 ? void 0 : params.getWindowRef;
        this.captureError = params === null || params === void 0 ? void 0 : params.captureError;
    }
    Object.defineProperty(WixSdkAdapter.prototype, "windowRef", {
        get: function () {
            var _a;
            return ((_a = this.getWindowRef) === null || _a === void 0 ? void 0 : _a.call(this)) || win_1.win;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WixSdkAdapter.prototype, "Wix", {
        get: function () {
            return this.isAvailable() ? this.windowRef.Wix : undefined;
        },
        enumerable: false,
        configurable: true
    });
    return WixSdkAdapter;
}());
exports.WixSdkAdapter = WixSdkAdapter;
//# sourceMappingURL=index.js.map